var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.43 18.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visualizar_perfil_inativo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1683268896624",
    "data-name": 1683268896624
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.05c0,.55.05.66.5,1.22l4.17,4.34c.29.23.51.42.81.64,3.37,2.53,7.46,4.17,12,2.49.55-.21,1.06-.41,1.55-.65s1.07-.5,1.07-1.29a1.07,1.07,0,0,0-.33-.73c-.82-.74-1.63.16-3,.63a8.24,8.24,0,0,1-3.33.53c-2.55,0-5.73-1.86-7.32-3.28-.13-.12-.2-.16-.33-.27L3,9.84a3.24,3.24,0,0,1-.49-.63,2.9,2.9,0,0,1,.46-.6c.53-.57,1-1.13,1.61-1.77a2,2,0,0,1,.29-.24L7,4.77c.44-.32.86-.61,1.34-.9a15.9,15.9,0,0,1,1.48-.78c4-1.95,8.06-.5,11.28,2.15L23,7l0,0,0,0,.05,0L25,9.21a25.2,25.2,0,0,1-2.13,2.43c-.42.41-.61.44-.61,1.11a1.1,1.1,0,0,0,1.13,1c.66,0,1.58-1.22,2-1.68a21.32,21.32,0,0,0,1.45-1.7,2.46,2.46,0,0,0,.6-1.07V9.06c-.06-.44-.46-.9-1.14-1.71L23.51,4.46,22,3.17C16.34-1,11.13-1.07,5.51,3.15A26.62,26.62,0,0,0,3.23,5.1l-.72.73-1,1.09C1.14,7.32.56,8.08.23,8.53A1.07,1.07,0,0,0,0,9.05Z",
    transform: "translate(0 0)",
    fill: "#183a78",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,9.26a2.52,2.52,0,1,1,2.52,2.47A2.51,2.51,0,0,1,11.2,9.26ZM9,9.21A4.7,4.7,0,0,0,16.54,13,4.67,4.67,0,0,0,18,7.36a4.83,4.83,0,0,0-1.49-1.88A4.72,4.72,0,0,0,9.41,7.32,5.42,5.42,0,0,0,9,9.21Z",
    transform: "translate(0 0)",
    fill: "#183a78",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEye);
export default __webpack_public_path__ + "static/media/blueEye.e0214258482129d4993b1be32696ec85.svg";
export { ForwardRef as ReactComponent };